import { useState } from 'react'
import { t } from 'i18next'
import { IFormModel } from 'types'

/**
 * Form constants
 */
const SEARCH = 'search'
const GRADE_LEVEL = 'grade_level'
const SUBJECT = 'subject'
const CONTENT_AREA = 'content_area'
const DOMAIN = 'domain'
const COMPLEXITY = 'complexity'

/**
 * Form model
 */
const formModel = (): IFormModel  => {
  return {
    [SEARCH]: {
      label: `${t('common.search-table')}`,
      name: SEARCH,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
    },
    [SUBJECT]: {
      label: `${t('common.subject')}`,
      name: SUBJECT,
    },
    [CONTENT_AREA]: {
      label: `${t('common.content-area')}`,
      name: CONTENT_AREA,
    },
    [DOMAIN]: {
      label: `${t('common.domain')}`,
      name: DOMAIN,
    },
    [COMPLEXITY]: {
      label: `${t('common.complexity')}`,
      name: COMPLEXITY,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SEARCH]: '',
  [GRADE_LEVEL]: null,
  [SUBJECT]: null,
  [CONTENT_AREA]: null,
  [DOMAIN]: null,
  [COMPLEXITY]: null,

}

/**
 * Form state
 */
export const useParams = () => {
  const [params, setParams] = useState(initialValues)

  return { params, setParams }
}

export default formModel
